
import { APP_ROUTES } from "constants/appRoutes";
import { useEffect } from "react";
import { withRouter } from 'react-router-dom';

const GlobalHotKeys = ({history}) => {
    useEffect(() => {
        const handler = (e) => {
            if (e.altKey && e.code === 'KeyR') {
                e.preventDefault();
                history.push(APP_ROUTES.LIST_REFILLS);
              }
            if (e.altKey && e.code === 'KeyP') {
                e.preventDefault();
                history.push(APP_ROUTES.PRODUCT_CATALOG);
              }
        }
        window.addEventListener('keydown' , handler);
        return () => window.removeEventListener('keydown' , handler)
    }, [history])
return null ;
};
export default withRouter(GlobalHotKeys);